import { render, staticRenderFns } from "./BonoErrorMessagesModal.vue?vue&type=template&id=351d29aa"
import script from "./BonoErrorMessagesModal.vue?vue&type=script&lang=js"
export * from "./BonoErrorMessagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports